import { PaperProps, Paper, Grid, Card, Dialog, DialogTitle, Select, MenuItem, InputLabel, FormControl, CircularProgress } from "@mui/material";
import { FieldArray, Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import MDBox from "../../../../Components/MDBox";
import MDButton from "../../../../Components/MDButton";
import MDInput from "../../../../Components/MDInput";
import { ErrorToaast, SuccessToaast } from "../../../../utils/toast/Toast";
import { GhabzModel } from "../../../../Api/Models/GhabzModel";
import { GhabzDto } from "../../../../Types/Api/DTO/GhabzDto";
import { v4 as uuid } from "uuid";
import MDDate from "../../../../Components/MDDate";
import MDDivider from "../../../../Components/MDDivider";
import MDTypography from "../../../../Components/MDTypography";
import * as Yup from "yup";
import Subscribers from "../..";
import { SubscriberModel } from "../../../../Api/Models/SubscriberModel";

function PaperComponent(props: PaperProps) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
export default function AddSubscriber({
  open,
  setClose,
  onDone,
}: // loading,
// setLoading,
{
  open: boolean;
  setClose: any;
  onDone: any;
  loading: boolean;
  setLoading: any;
}) {
  const ghabzModel = new GhabzModel();
  const subscriberModel = new SubscriberModel();
  const [ghabzSelected, setGhabzSelected] = useState<{ active: boolean; data: GhabzDto[] }>({ active: false, data: [] });
  const [ghabzSelect, setGhabzSelect] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  useEffect(() => {
    setLoading(true);
    ghabzModel
      .getAll()
      .then((r) => {
        let data = r.data.data as any[];
        if (data.length < 1) {
          ErrorToaast("هیچ قالب قبضی وجود ندارد");
          setClose();
        } else {
          setGhabzSelected({ active: true, data });
        }
        setLoading(false);
      })
      .catch((r) => ErrorToaast("مشکل در برقراری ارتباط"));
    return () => {};
  }, []);
  async function handleGhabzSelect(value: any, arrayHelpers: any) {
    if (value === "") {
      setGhabzSelect("");
      return;
    }
    setLoading(true);
    await ghabzModel.get(parseInt(value)).then((r: any) => {
      setGhabzSelect(value);

      var data = r.data.data.ghabzFields as any[];
      data.forEach((d) => {
        arrayHelpers?.push({ name: d.fieldName, id: d.id, value: "" });
      });
      setLoading(false);

      // const validateSchema = yup.object().shape(yepSchema);
    });
  }
  interface IinitialValues {
    Fields: {
      name: string;
      id: number;
      value: string;
    }[];
    ExpireDate: string;
    Subscriber: string;
  }
  const initialValues: IinitialValues = {
    Fields: [],
    ExpireDate: "",
    Subscriber: "",
  };
  const validationSchema = Yup.object({
    Fields: Yup.array().of(
      Yup.object().shape({
        value: Yup.string().required("الزامی است"),
      })
    ),
    ExpireDate: Yup.string().required("الزامی است"),
    Subscriber: Yup.string().required("الزامی است"),
  });
  async function handleSubmit(values: IinitialValues) {
    await setLoading(true);
    var modelToSend = {
      GhabzId: parseInt(ghabzSelect),
      Subscriber: values.Subscriber,
      ExpireDate: values.ExpireDate,
      SubscribeRows: values.Fields,
    };
    await subscriberModel
      .crete(modelToSend)
      .then((r) => {
        SuccessToaast("با موفقیت اضافه شد");
      })
      .catch((r) => {
        ErrorToaast("موفقیت آمیز نبود");
      });
    await onDone();
    await setClose();
    setLoading(false);
  }
  return (
    <Dialog open={open} onClose={() => setClose(true)} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title" fullWidth>
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        افزودن
      </DialogTitle>
      <Card>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(data) => {
            setIsSubmited(true);
            handleSubmit(data);
          }}
        >
          {(formikChild) => (
            <Form>
              <FieldArray
                name="Fields"
                render={(arrayHelpers) => {
                  // setarrayHelp(arrayHelpers);
                  const Fields = formikChild.values.Fields;

                  return (
                    <>
                      <MDBox pt={4} pb={3} px={2}>
                        <Grid container columnSpacing={3} rowSpacing={2}>
                          <Grid item xs={12} md={12} lg={4}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-helper-label">انتخاب قبض</InputLabel>
                              <Select
                                labelId="select_ghabz"
                                id="select_ghabz"
                                value={ghabzSelect}
                                label="انتخاب قبض"
                                onChange={async (e) => {
                                  await formikChild.setFieldValue("Fields", []);
                                  await formikChild.resetForm();
                                  await handleGhabzSelect(e.target.value, arrayHelpers);
                                }}
                                disabled={loading}
                              >
                                <MenuItem value="">None</MenuItem>
                                {ghabzSelected.data.map((r: any) => {
                                  return (
                                    <MenuItem value={r.id} key={uuid()}>
                                      {r.avarezName}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={12} lg={4}>
                            <MDInput
                              type="name"
                              name="name"
                              disabled={loading}
                              onChange={(e: any) => formikChild.setFieldValue("Subscriber", e.target.value)}
                              error={formikChild.touched.Subscriber && Boolean(formikChild.errors.Subscriber)}
                              helperText={formikChild.touched.Subscriber && formikChild.errors.Subscriber}
                              value={formikChild.values.Subscriber}
                              label="کد اشتراک"
                              fullWidth
                            />
                          </Grid>
                          <Grid item xs={12} md={12} lg={4}>
                            <MDDate
                              name={"DateEnd"}
                              onChange={(e: any) => formikChild.setFieldValue("ExpireDate", e)}
                              error={formikChild.touched.ExpireDate && Boolean(formikChild.errors.ExpireDate)}
                              helperText={formikChild.touched.ExpireDate && formikChild.errors.ExpireDate}
                              defaultValue={formikChild.values.ExpireDate}
                              portal
                              disabled={loading}
                              label={"تاریخ اتمام"}
                            ></MDDate>
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            <MDTypography fontSize={16}>پارامتر های قبض</MDTypography>
                            <MDDivider />
                          </Grid>
                          {loading && (
                            <Grid container item xs={12} md={12} lg={12} justifyContent="center">
                              <CircularProgress />
                            </Grid>
                          )}
                          {Fields &&
                            Fields.length > 0 &&
                            Fields.map((item, index) => {
                              return (
                                <Grid item xs={12} md={12} lg={3} key={index}>
                                  <MDInput
                                    disabled={loading}
                                    // onBlur={() => handleValidate(r.FieldId)}
                                    // error={r.Error}
                                    helperText={formikChild.touched.Fields?.[index] && Boolean(formikChild.errors.Fields?.[index]) && "الزامی است "}
                                    error={formikChild.touched.Fields?.[index] && Boolean(formikChild.errors.Fields?.[index])}
                                    fullWidth
                                    label={item.name}
                                    value={item.value}
                                    onChange={(e: any) => {
                                      formikChild.setFieldValue(`Fields[${index}].value`, e.target.value);
                                    }}
                                  />
                                </Grid>
                              );
                            })}
                        </Grid>
                        <Grid container spacing={3} mt={1} justifyContent="flex-end">
                          <Grid item alignSelf={"center"}>
                            {!formikChild.isValid && (
                              <MDTypography color="error" fontSize="12px">
                                لطفا داده ها را مجددا برسی نمایید
                              </MDTypography>
                            )}
                          </Grid>
                          <Grid item>
                            <MDButton variant="contained" color="info" type="submit" onClick={() => {}}>
                              ثبت
                            </MDButton>
                          </Grid>
                          <Grid item>
                            <MDButton variant="gradient" color="success" onClick={() => setClose()}>
                              انصراف
                            </MDButton>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </>
                  );
                }}
              />
            </Form>
          )}
        </Formik>
      </Card>
    </Dialog>
  );
}
